import React, { useState, useEffect, useRef } from 'react'
import Tools from "../../components/Tools/Tools";
import TDSReportList from "../../components/Reports/TDSReportList";
import ManageDisbursmentHeader from "../../components/Disbursment/ManageDisbursmentHeader";
import TDSReportFilter from '../Filter/TDSReportFilter';
import { getTDSReports, get_financial_year,get_consolidate_disbursment_invoices} from "../../helper/Api";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    GET_D_INVOICES_START,
    GET_D_INVOICES_SUCCESS,
    GET_D_INVOICES_FAIL
} from '../../RTK/Slices/DisbursmentInvoiceSlice';
const TDSitReport = () => {
    const dispatch = useDispatch();
    const { authData } = useSelector((state) => state.authData);
    const location = useLocation();
    const [filter, setFilter] = useState('own');
    const fromDate = useRef('');
    const toDate = useRef('');
    const searchStrRef = useRef('');
    const fyIdRef = useRef(2);
    const departmentIdRef = useRef('');
    const departmentId1Ref = useRef('');
    const tierRef = useRef('');
    const [fyList, setFyList] = useState([]);
    const [data, setData] = useState([]);
    const handleDateChange = (fromDatevalue, toDateValue, searchStr, fyId, tier, departmentId, departmentId1) => {
        fromDate.current = fromDatevalue;
        toDate.current = toDateValue;
        searchStrRef.current = searchStr;
        fyIdRef.current = fyId;
        tierRef.current = tier;
        departmentIdRef.current = departmentId;
        departmentId1Ref.current = departmentId1;
        if (filter == 'child') {
            fetchChallans();
        }
        else if (filter == 'consolidate') {
            fetchReportsConsolidate();
        }
    };
    const fetchChallans = async () => {
        try {
            const resp = await getTDSReports({
                from_date: fromDate.current || "",
                to_date: toDate.current || "",
                search_str: searchStrRef.current || '',
                fy_id: fyIdRef.current || '',
                department_id: departmentIdRef.current || '',
            });
            if (resp.data.status) {
                setData(resp.data.list);
            }
        } catch (error) {
            setData([]);
        }
    }
    const fetchReportsConsolidate = async () => {
        try {
            let departmentId = '';
            if (departmentIdRef.current !== "" && departmentId1Ref.current !== "") {
                departmentId = departmentId1Ref.current;
            }
            else {
                departmentId = departmentIdRef.current;
            }
            const invoiceData = await getTDSReports({
                parent_department_id: departmentId || 1,
                fy_id: fyIdRef.current || '',
                from_date: fromDate.current || "",
                to_date: toDate.current || "",
                search_str: searchStrRef.current || '',
            });
            if (invoiceData.data.status) {
                dispatch(GET_D_INVOICES_SUCCESS(invoiceData.data.list))
                setData(invoiceData.data.list)
            } else {
                dispatch(GET_D_INVOICES_FAIL('something went wrong'))
            }
        } catch (error) {
            dispatch(GET_D_INVOICES_FAIL('something went wrong'));
        }

    }
    const fetchFinancialYears = async () => {
        const fy = await get_financial_year();
        if (fy.data.status) {
            setFyList(fy.data.list);
        }
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const newReportType = queryParams.get('reportType') || 'own';  // default fallback
        setFilter(newReportType);
        fetchFinancialYears();
        if (newReportType == 'own') {
            fetchChallans();
        }
        else {
            setData([]);
        }
    }, [location.search]);
    return (
        <div>
            {/* <Tools /> */}
            {/* <div className='addNewScheme'>
                <div className="add_new_user">
                    <h4>TDS-IT</h4>
                </div>
            </div> */}
            <ManageDisbursmentHeader onDateChange={handleDateChange} type="TDS IT REPORT" />
            <TDSReportFilter filterType={filter} onDateChange={handleDateChange} fyData={fyList} />
            <div className='scheme p-3'>
                <TDSReportList data={data} />
            </div>
        </div>
    )
}

export default TDSitReport
